//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import i18n from "@/utils/i18n";
import { isEmptyStr } from "@/utils/util";
export default {
  name: "name-editor",
  mixins: [i18n],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  },
  inject: ['serverFieldList', 'getDesignerConfig'],
  data: function data() {
    return {
      nameRequiredRule: [{
        required: true,
        message: 'name required'
      }]
    };
  },
  computed: {
    noFieldList: function noFieldList() {
      return !this.serverFieldList || this.serverFieldList.length <= 0;
    },
    widgetNameReadonly: function widgetNameReadonly() {
      return !!this.getDesignerConfig().widgetNameReadonly;
    }
  },
  methods: {
    updateWidgetNameAndRef: function updateWidgetNameAndRef(newName) {
      var oldName = this.designer.selectedWidgetName;
      if (isEmptyStr(newName)) {
        this.selectedWidget.options.name = oldName;
        this.$message.info(this.i18nt('designer.hint.nameRequired'));
        return;
      }
      if (!!this.designer.formWidget) {
        var foundRef = this.designer.formWidget.getWidgetRef(newName); // 检查newName是否已存在！！
        if (!!foundRef) {
          this.selectedWidget.options.name = oldName;
          this.$message.info(this.i18nt('designer.hint.duplicateName') + newName);
          return;
        }
        var widgetInDesign = this.designer.formWidget.getWidgetRef(oldName);
        if (!!widgetInDesign && !!widgetInDesign.registerToRefList) {
          widgetInDesign.registerToRefList(oldName); //注册组件新的ref名称并删除老的ref！！
          var newLabel = this.getLabelByFieldName(newName);
          this.designer.updateSelectedWidgetNameAndLabel(this.selectedWidget, newName, newLabel);
        }
      }
    },
    getLabelByFieldName: function getLabelByFieldName(fieldName) {
      for (var i = 0; i < this.serverFieldList.length; i++) {
        if (this.serverFieldList[i].name === fieldName) {
          return this.serverFieldList[i].label;
        }
      }
      return null;
    }
  }
};